<template>
    <div class="loginContent">
        <div class="loginPos">
            <el-image :src="require('@/assets/icon/logo.png')" fit="cover" class="logo"></el-image>
            <div class="loginBox">
                <div class="align" v-if="loginType == '0'">
                    <div :class="['loginTab', active == index ? 'loginTabOn' : '']" v-for="(item, index) in tab" :key="index" @click="active = index">{{ item }}</div>
                </div>
                <div class="loginTab loginTabOn" v-else>{{ loginType == '1' ? '手机注册' : '忘记密码' }}</div>
                <div :class="['loginIptBox between', phoneFocus ? 'focus' : (phoneBlurred && phone == '' ? 'empty' : '')]">
                    <el-image :src="require('@/assets/icon/login01.png')" fit="cover" class="loginIptIcon"></el-image>
                    <el-input placeholder="请输入手机号" v-model="phone" clearable class="loginIpt" @focus="phoneFocus = true; phoneBlurred = false" @blur="phoneFocus = false; phoneBlurred = true"></el-input>
                </div>
                <div :class="['loginIptBox between', codeFocus ? 'focus' : (codeBlurred && code == '' ? 'empty' : '')]" v-if="loginType == '0' && active == '0' || loginType != '0'">
                    <el-image :src="require('@/assets/icon/login02.png')" fit="cover" class="loginIptIcon"></el-image>
                    <el-input placeholder="请输入验证码" v-model="code" clearable class="loginIpt" @focus="codeFocus = true; codeBlurred = false" @blur="codeFocus = false; codeBlurred = true"></el-input>
                    <div :class="['codeBtn',time != '0' ? 'codeBtnNo' : '']" @click="codeBtnTap">{{ time == '0' ? '发送验证码' : time + 's 后重新获取' }}</div>
                </div>
                <div :class="['loginIptBox between', passFocus ? 'focus' : (passBlurred && pass == '' ? 'empty' : '')]" v-if="loginType == '0' && active == '1' || loginType != '0'">
                    <el-image :src="require('@/assets/icon/login03.png')" fit="cover" class="loginIptIcon"></el-image>
                    <el-input placeholder="请输入密码" v-model="pass" clearable class="loginIpt" @focus="passFocus = true; passBlurred = false" @blur="passFocus = false; passBlurred = true"></el-input>
                </div>
                <div class="forget" v-if="loginType == '0' && active == 1" @click="forgetTap">忘记密码</div>
                <div class="loginBtn" @click="loginBtnTap">{{ loginType == '0' ? '登录' : loginType == '1' ?  '注册' : loginType == '2' ? '确认修改' : '' }}</div>
                <div class="loginTips">登录即表示同意<span class="loginTipsSpan">《用户注册协议》</span><span class="loginTipsSpan">《用户隐私协议》</span></div>
                <div class="loginWay" @click="loginWayTap">{{ loginType == '0' ? '免费注册' : '已有账号?' }}<span class="loginWaySpan" v-if="loginType != '0'">登录</span></div>
            </div>
        </div>
    </div>
</template>
<script>
    let count = null
    export default{
        data(){
            return {
                loginType: '0', // 0: 登录，1: 注册，2: 忘记密码
                tab: ['验证码登录','密码登录'],
                active: 0, // 0: 验证码登录，1: 密码登录
                phone: '',
                code: '',
                pass: '',
                time: 0,
                phoneFocus: false,
                codeFocus: false,
                passFocus: false,
                phoneBlurred: false,
                codeBlurred: false,
                passBlurred: false
            }
        },
        watch: {
            loginType() {
                // 当 loginType 改变时，重置所有输入框的边框状态
                this.resetInputBoxStates();
            },
            active() {
                // 当 active 改变时，重置所有输入框的边框状态
                this.resetInputBoxStates();
            }
        },
        created(){
            
        },
        mounted(){
            // 添加全局键盘事件监听
            document.addEventListener('keydown', this.handleKeyDown);
        },
        beforeDestroy(){
            // 移除事件监听
            document.removeEventListener('keydown', this.handleKeyDown);
        },
        methods: {
            // 处理键盘事件
            handleKeyDown(e){
                if(e.key === 'Enter'){
                    e.preventDefault(); // 阻止默认行为
                    this.loginBtnTap(); // 只执行一次登录方法
                }
            },
            // 获取验证码
            codeBtnTap(){
                var that = this
                if(that.time == 0){
                    if(!/^1[3456789]\d{9}$/.test(that.phone)){
                        that.$message.error('请输入正确的手机号');
                        return
                    }
                    that.request.post("index/User/send",{
                        mobile: that.phone
                    })
                    .then(res=>{
                        if(res.code == '1'){
                            that.$message({
                                message: '发送成功',
                                type: 'success'
                            });
                            that.time = 60
                            count = setInterval(function(){
                                that.time--
                                if(that.time == 0){
                                    clearInterval(count)
                                }
                            },1000)
                        }else{
                            that.$message.error(res.msg);
                        }
                    })
                }
            },
            // 登录、注册、修改密码
            loginBtnTap(){
                let that = this
                if(!/^1[3456789]\d{9}$/.test(that.phone)){
                    that.$message.error('请输入正确的手机号');
                    return
                }
                if(that.loginType == '0'){
                    if(that.code == '' && that.active == '0'){
                        that.$message.error('请输入验证码');
                        return
                    }
                    if(that.pass == '' && that.active == '1'){
                        that.$message.error('请输入密码');
                        return
                    }
                    that.request.post("index/User/login",{
                        mobile: that.phone,
                        password: that.pass,
                        code: that.code,
                        type: that.active
                    })
                    .then(res=>{
                        if(res.code){
                            localStorage.setItem('userId',res.data.userid)
                            that.$message({
                                message: '登录成功',
                                type: 'success'
                            });
                            setTimeout(()=>{
                                that.$router.push({path:'/'})
                            },1000)
                        }else{
                            that.$message.error(res.msg);
                        }
                    })
                }
                if(that.loginType == '1'){
                    if(that.code == ''){
                        that.$message.error('请输入验证码');
                        return
                    }
                    if(that.pass == ''){
                        that.$message.error('请输入密码');
                        return
                    }
                    that.request.post("index/User/register",{
                        mobile: that.phone,
                        password: that.pass,
                        code: that.code
                    })
                    .then(res=>{
                        if(res.code){
                            that.$message({
                                message: '注册成功',
                                type: 'success'
                            });
                            that.loginType = '0'
                            that.getData()
                        }else{
                            that.$message.error(res.msg);
                        }
                    })
                }
                if(that.loginType == '2'){
                    if(that.code == ''){
                        that.$message.error('请输入验证码');
                        return
                    }
                    if(that.pass == ''){
                        that.$message.error('请输入密码');
                        return
                    }
                    that.request.post("index/User/resetpassword",{
                        mobile: that.phone,
                        password: that.pass,
                        code: that.code
                    })
                    .then(res=>{
                        if(res.code){
                            that.$message({
                                message: '修改密码成功',
                                type: 'success'
                            });
                            that.loginType = '0'
                            that.getData()
                        }else{
                            that.$message.error(res.msg);
                        }
                    })
                }
            },
            // 忘记密码
            forgetTap(){
                this.loginType = '2'
                this.getData()
            },
            // 注册、登录切换
            loginWayTap(){
                this.loginType = this.loginType == '0' ? '1' : '0'
                this.getData()
            },
            // 数据重置
            getData(){
                clearInterval(count)
                this.time = 0
                this.active = 0
                this.phone = ''
                this.code = ''
                this.pass = ''
            },
            // 重置输入框边框状态
            resetInputBoxStates(){
                this.phoneBlurred = false;
                this.codeBlurred = false;
                this.passBlurred = false;
                this.phoneFocus = false;
                this.codeFocus = false;
                this.passFocus = false;
            }
        }
    }
</script>
<style lang="less" scoped>
    .loginContent{
        width: 100vw;
        height: 100vh;
        min-height: 940px;
        background: url('~@/assets/image/loginBg.jpg') no-repeat center/cover;
        overflow-y: scroll;
        .loginPos{
            width: 420px;
            height: 100vh;
            padding-bottom: 94px;
            min-height: 752px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            position: fixed;
            top: 0;
            right: 18%;
            .logo{
                height: 75px;
            }
            .loginBox{
                width: 338px;
                padding: 60px 40px 40px 40px;
                background: #fff;
                border-radius: 8px;
                border: 1px solid #F0F0F0;
                margin-top: 32px;
                .loginTab{
                    font: 20px/26px "Microsoft YaHei";
                    color: #73727A;
                    margin-left: 44px;
                    cursor: pointer;
                    &:first-child{
                        margin-left: 0;
                    }
                    &.loginTabOn{
                        color: #000;
                        font-weight: bold;
                    }
                }
                .loginIptBox{
                    width: 336px;
                    height: 50px;
                    background: #FAFAFA;
                    border-radius: 8px;
                    border: 1px solid #FAFAFA;
                    margin-top: 32px;
                    // transition: border-color 0.3s;
                    &.focus {
                        border-color: #00BF7F;
                    }
                    &.empty {
                        border-color: #F60000;
                    }
                    .loginIptIcon{
                        width: 20px;
                        height: 20px;
                        margin-left: 12px;
                    }
                    .loginIpt{
                        flex: 1;
                        height: 50px;
                        font: 16px/50px "Microsoft YaHei";
                        color: #595959;
                        /deep/ .el-input__inner {
                            height: 50px;
                            line-height: 50px;
                            border: none;
                            background: none;
                        }
                        /deep/ .el-input__inner:focus {
                            background: transparent;
                        }
                    }
                    .codeBtn{
                        font: 14px/50px "Microsoft YaHei";
                        cursor: pointer;
                        margin-right: 12px;
                    }
                    .codeBtnNo{
                        color: #ADACB1;
                        cursor: not-allowed !important;
                    }
                }
                .forget{
                    font: 14px/18px "Microsoft YaHei";
                    color: #73727A;
                    text-align: right;
                    margin-top: 8px;
                    cursor: pointer;
                }
                .loginBtn{
                    width: 338px;
                    height: 48px;
                    background: #00BF7F;
                    border-radius: 8px;
                    font: 18px/48px "Microsoft YaHei";
                    color: #fff;
                    text-align: center;
                    cursor: pointer;
                    margin-top: 68px;
                }
                .loginTips{
                    font: 14px/18px "Microsoft YaHei";
                    color: #ADACB1;
                    margin-top: 16px;
                    .loginTipsSpan{
                        color: #47474F;
                        cursor: pointer;
                    }
                }
                .loginWay{
                    font: 14px/18px "Microsoft YaHei";
                    color: #73727A;
                    text-align: center;
                    cursor: pointer;
                    margin-top: 32px;
                    .loginWaySpan{
                        color: #00BF7F;
                        padding-left: 8px;
                    }
                }
            }
        }
    }
</style>